import { Box } from "@mui/material";
import Image from "next/image";
import { Flex } from "rebass";
import { Parallax  } from 'react-scroll-parallax';
import { Tiles } from "@rebass/layout";

const AppImage = ({src} : {src: string}) => {
  return (
    <Image
      src={src}
      // className="tiles__line-img"
      alt="appscreen"
      width={520}
      // layout="responsive"
      // objectFit="fill"
      height={782}
      style={{
        maxWidth: "100%",
        height: "auto"
      }} />
  );
}

const ParallaxSection = () => {
  return (
    <Flex
      height={["60vh","80vh","110vh"]}
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        overflowX: "hidden",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden"
      }}
      // className="tiles tiles--columns"
      // id="grid3"
    >
      {/* <div className="tiles__wrap"> */}
        {/* <div
          className="tiles__line"
          data-scroll
          data-scroll-speed="6"
          data-scroll-target="#grid3"
          data-scroll-direction="vertical"
        > */}

        <Tiles columns={[3,3,3]} sx={{gap: "2rem", px: "2%"}}>

        <Parallax translateY={[80, -80]} speed={40}>
          <Flex sx={{gap: "2rem", mt: "20rem", alignItems: 'flex-start'}} flexDirection="column">
          <AppImage src="/images/appscreen1.png"/>
          <AppImage src="/images/appscreen3.png"/>
          </Flex>
        </Parallax>

        <Parallax translateY={[20, -20]} speed={50}>
          <Flex sx={{gap: "2rem", mt: "30rem"}} flexDirection="column">
          <AppImage src="/images/appscreen2.png"/>
          <AppImage src="/images/appscreen4.png"/>
          </Flex>
        </Parallax>

        <Parallax translateY={[60, -60]} speed={65}>
          <Flex sx={{gap: "2rem", mt: "25rem",}} flexDirection="column">
          <AppImage src="/images/appscreen5.png"/>
          <AppImage src="/images/appscreen6.png"/>
          </Flex>
        </Parallax>
      </Tiles>
      {/* </div> */}
      <Box
        sx={{
          height: "290px",
          width: "100%",
          display: "block",
          bottom: -5,
          background:"linear-gradient(180deg, rgba(18, 18, 18, 0) 0%, #121212 90%)",
          zIndex:"999",
          position: "absolute"
        }}
      >
      </Box>
      {/* <Box
        sx={{
          height: "290px",
          width: "100%",
          display: "block",
          top: 0,
          background:"linear-gradient(0deg, rgba(18, 18, 18, 0) 0%, #121212 90%)",
          zIndex:"999",
          position: "absolute"
        }}
      >
      </Box> */}
    </Flex>
  );
};

export default ParallaxSection;
